import * as types from '../constants/action-types';
import { getWebEnv, getSpaceEnv, getAddOnsCategories } from '../../../../api/api-env';
import SharedIntlProviderHOC from '../../shared-components/hocs/sharedIntlProviderHOC';

export function fetchEnvRequest () {
  return {
    type: types.ENV_FETCH_REQUEST
  };
}

export function fetchEnvSuccess (web) {
  return {
    type: types.ENV_FETCH_SUCCESS,
    web
  };
}

function fetchEnvFailure (error) {
  return {
    type: types.ENV_FETCH_FAILURE,
    error
  };
}

export function fetchEnvWeb () {
  const locale = SharedIntlProviderHOC.getLocale();
  return dispatch => {
    dispatch(fetchEnvRequest());
    getWebEnv(locale, (response) => {
      if (response.error) {
        return dispatch(fetchEnvFailure(response.error));
      }
      return dispatch(fetchEnvSuccess(response));
    });
  };
}

export function fetchEnvSpace (locale) {
  return dispatch => {
    dispatch(fetchEnvRequest());
    getSpaceEnv(locale, (response) => {
      if (response.error) {
        return dispatch(fetchEnvFailure(response.error));
      }
      return dispatch({
        type: types.ENV_FETCH_SUCCESS,
        space: response
      });
    });
  };
}

export function fetchEnvAddOnsRequest () {
  return {
    type: types.ENV_ADDONS_FETCH_REQUEST
  };
}

export function fetchEnvAddOnsSuccess (addOns) {
  return {
    type: types.ENV_ADDONS_FETCH_SUCCESS,
    addOns
  };
}

export function fetchEnvAddOnsFailure (error) {
  return {
    type: types.ENV_ADDONS_FETCH_FAILURE,
    error
  };
}

export function fetchEnvAddOns () {
  const locale = SharedIntlProviderHOC.getLocale();

  return dispatch => {
    dispatch(fetchEnvAddOnsRequest());

    getAddOnsCategories(locale, (response) => {
      if (response.error) {
        return dispatch(fetchEnvAddOnsFailure(response));
      }
      return dispatch(fetchEnvAddOnsSuccess(response));
    });
  };
}
